import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import { FilterItemProps } from '@/components/Filter/FilterItem/types';

const ProjectStageItem = ({
  isSelected,
  option,
}: {
  isSelected?: boolean;
  option: FilterItemProps['option'];
}) => (
  <>
    {option.Icon ? (
      <Stack
        alignItems="center"
        className={cn('me-2 ms-12', isSelected ? 'text-icon-active' : 'text-icon-secondary')}
        justifyContent="center">
        <option.Icon className="h-18 w-18" />
      </Stack>
    ) : null}
    <Typography
      className="xs:body-short-01 truncate ms-12"
      color={isSelected ? 'text-text-primary' : 'text-text-secondary'}
      variant="body-short-02">
      {option.label}
    </Typography>
  </>
);

export default ProjectStageItem;
